import { decomposeColor } from '@material-ui/core/styles';

export type PerceivedBrightness = 'light' | 'dark';

type RGB = {
  r: number;
  g: number;
  b: number;
};

/**
 * Determine whether a color is "light" or "dark"
 */
export function getPerceivedBrightnessFromHex(color: string): PerceivedBrightness {
  const { r, g, b } = getDecomposedRGBValues(color);

  // See http://alienryderflex.com/hsp.html for information regarding equation
  const brightness = Math.sqrt(0.299 * (r * r) + 0.587 * (g * g) + 0.114 * (b * b));

  // Using the brightness value, determine whether the color is light or dark
  if (brightness > 127.5) {
    return 'light';
  } else {
    return 'dark';
  }
}

function getDecomposedRGBValues(hex: string): RGB {
  const [r, g, b] = decomposeColor(hex).values;
  return { r, g, b };
}
